import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ReactComponent as LogoIcon } from "../../assets/logo/logo-centralis-gris.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/view-more.svg";
import { ReactComponent as EyeSlashIcon } from "../../assets/icons/visibility-off.svg";
import Button from '../../composants/Button/Button';
import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      
      // Récupérer les informations utilisateur du localStorage
      const userDataString = localStorage.getItem('user');
      const userData = userDataString ? JSON.parse(userDataString) : {};
      const userRoles = userData.role ? [userData.role] : (userData.roles || []);
      console.log('Rôles de l\'utilisateur:', userRoles);
      console.log('Rôle principal de l\'utilisateur:', userData.role);
      // Vérifier si l'utilisateur a un rôle d'acheteur
      const isAcheteur = userRoles.some((role: string) => 
        role === "Acheteur" || 
        role === "Acheteur signataire" || 
        role === "Acheteur signataire admin"
      );
      
      // Rediriger vers la page appropriée selon le rôle
      navigate(isAcheteur ? '/operations' : '/commandes');
      
    } catch (error) {
      setError('Email ou mot de passe incorrect');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <LogoIcon className="logo" />
        </div>
        <h1>Connexion</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
          <Button
            type="submit"
            variant="primary"
            value={isLoading ? "Connexion en cours..." : "Se connecter"}
            size="medium"
            disabled={isLoading}
          />
        </form>
        <div className="login-footer">
          <p className="register-link">
            Vous n'avez pas de compte ? <Link to="/register">Faire une demande d'inscription</Link>
          </p>
          <p className="forgot-password-link">
            <Link to="/forgot-password">Mot de passe oublié ?</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;